import { render, staticRenderFns } from "./CustomersDataTableForLazyWithResize.vue?vue&type=template&id=cc1de0e6&scoped=true"
import script from "./CustomersDataTableForLazyWithResize.vue?vue&type=script&lang=js"
export * from "./CustomersDataTableForLazyWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1de0e6",
  null
  
)

export default component.exports